export class AdminApiError extends Error {
    constructor(
        public readonly code: number,
        message: string | null
    ) {
        super(message ?? `Admin API error (code ${code})`);
        this.name = 'AdminApiError';
    }
}
